import { FiCheckCircle } from 'react-icons/fi';
import * as s from '../style';
import IconType from '../type';

export const IconJSX = ({
  title,
  color,
  onClick,
  style,
  className,
  size,
  disabled = false,
}: IconType): JSX.Element => (
  <s.IconContainer
    style={{ color: color || 'inherit', ...style }}
    onClick={disabled ? () => null : onClick}
    title={title}
    className={`icon ${className}`}
    disabled={disabled}
    size={size}
  >
    <FiCheckCircle />
  </s.IconContainer>
);

export default IconJSX;
